import React from 'react';
import { useOfflineToggle } from './useOfflineToggle';

/**
 * Online/Offline toggle pill.
 *
 * The displayed state reflects *effective* connectivity: it shows Offline when the
 * user manually chose offline OR the browser actually lost its connection. When the
 * connection is genuinely down the button is disabled, since you can't force "online"
 * without a network — it flips back automatically once the browser reconnects.
 */
const OfflineToggle = ({ className = '', scale = 1 }) => {
  const { offline, isBrowserOnline, isManualOffline, toggle } = useOfflineToggle();

  const title = !isBrowserOnline
    ? 'No internet connection — working offline'
    : isManualOffline
      ? 'Working offline — click to go back online'
      : 'Online — click to work offline';

  return (
    <button
      onClick={toggle}
      disabled={!isBrowserOnline}
      title={title}
      aria-pressed={offline}
      style={scale !== 1 ? { transform: `scale(${scale})`, transformOrigin: 'center' } : undefined}
      className={`inline-flex items-center gap-2 text-sm h-9 px-3 rounded-md border transition-colors ${offline ? 'border-amber-300 bg-amber-50 text-amber-700 hover:bg-amber-100' : 'border-gray-300 hover:bg-gray-50 text-gray-700'} ${!isBrowserOnline ? 'opacity-70 cursor-not-allowed' : ''} ${className}`}
    >
      <span className={`h-2 w-2 rounded-full ${offline ? 'bg-amber-500' : 'bg-green-500'}`}></span>
      {offline ? 'Offline' : 'Online'}
    </button>
  );
};

export default OfflineToggle;
